import { Validator } from '@vista-digital/validator';
/**
 * Determines the tax mode.
 */
export var TaxMode;
(function (TaxMode) {
    /**
     * Ticket and item prices are displayed inclusive of tax.
     */
    TaxMode["Inclusive"] = "Inclusive";
    /**
     * Ticket and item prices are displayed exclusive of tax.
     */
    TaxMode["Exclusive"] = "Exclusive";
})(TaxMode || (TaxMode = {}));
export const taxModeValidator = Validator.oneOf(Object.values(TaxMode));
